import React from 'react';
import PropTypes from 'prop-types';
import {Form} from "react-bootstrap";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Loading from "../../component/Loading/Loading";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import Objects from "../../utils/Objects";
import NotFound from "../../component/NotFound/NotFound";
import Notify from "../../services/Notify";
import ReadpointService from "../../services/ReadpointService";
import AntennaCustomSelect from "./AntennaCustomSelect";
import FormButtons from '../../component/Form/FormButtons'

class ReadpointAntennaSelect extends React.Component {

  service = new ReadpointService();

  constructor(props) {
    super(props);
    this.state = {loading: true};
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (Objects.isNullOrUndefined(id)) {
      return;
    }
    this.setState({loading: true});
    this.service.findById(id).then(
        data => this.setState(
            {
              loading: false,
              readpoint: data,
              message: null
            }),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  submit(event) {
    event.preventDefault()
    const {history} = this.props;
    const {readpoint} = this.state;
    this.service.saveReadEquipments(readpoint.id, {readEquipmentUuid: this.readEquipmentUuid, version: readpoint.version}).then(
        () => Notify.success('Atualização efetuada') && history.goBack(),
        error => {
          Notify.error('Problema ao associar', error);
        }
    )
    ;
  }

  render() {
    const {history} = this.props;
    const {loading, readpoint} = this.state;

    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de Ponto de Controle" to="/list/readpoints"/>,
      <BreadcrumbItem key={3} title="Pontos de leitura do ponto de controle" active={true}/>];

    if (loading) {
      return <Loading/>;
    }

    if (Objects.isNullOrUndefined(readpoint)) {
      return <NotFound/>;
    }
    return (
        <Page title={`Antenas do Ponto de Leitura "${readpoint.friendlyName}"`} breadcrumbs={breadcrumbs}>
          <Box info>
            <Form onSubmit={this.submit}>
              <AntennaCustomSelect readPoint={readpoint} uuids={readpoint.readEquipmentUuid}
                                   setValue={(value) => this.readEquipmentUuid = value} history={history}/>
              <FormButtons history={history}/>
            </Form>
          </Box>
        </Page>);
  }
  ;
}

ReadpointAntennaSelect.defaultProps = {
  checkpoint: null,
};

ReadpointAntennaSelect.propTypes = {
  checkpoint: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default ReadpointAntennaSelect;



// WEBPACK FOOTER //
// ./src/gateways/antennas/ReadpointAntennaSelect.js